import { Button } from "@gradience/ui";
import { useFormContext } from "../util";

export function SubmitButton({ label = "Save" }: { label?: string }) {
  const form = useFormContext();
  return (
    <form.Subscribe
      selector={(state) => [
        state.isSubmitting,
        state.isPristine,
        state.errors.length > 0,
      ]}
    >
      {([isSubmitting, isPristine, isError]) => (
        <Button
          text={label}
          loading={isSubmitting}
          disabled={isPristine || isError}
          type="submit"
          variant="primary"
          style={{ alignSelf: "flex-start" }}
        />
      )}
    </form.Subscribe>
  );
}
